import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import HomeHero from './HomeHero';
import ResizeObserver from 'resize-observer-polyfill';
import tourImage from '../assets/ashan/WhatsApp Image 2025-10-06 at 08.19.22.jpeg';
import sigiriyaImage from '../assets/images/edited/pexels-costa-18498686.jpg';
import kandyImage from '../assets/images/edited/pexels-freestockpro-322437.jpg';
import galleImage from '../assets/images/edited/pexels-alfred-franz-114875410-32964277.jpg';
import oneDayImage from '../assets/Home/chathura-anuradha-subasinghe-40uQmE9Zq8g-unsplash-1024x683.jpg';
import twoDayImage from '../assets/Home/historical-background-in-nuwara-eliya.jpg';
import threeDayImage from '../assets/Home/800px-Sigiriya_(141688197).jpeg';
import fourDayImage from '../assets/Home/safari-trip-to-Yala-National-Park-1.jpg';
import sigiriyaImage2 from '../assets/ashan/21.jpeg';
import sigiriyaImage3 from '../assets/ashan/28.jpeg';
import kandyImage2 from '../assets/ashan/31.jpeg';
import kandyImage3 from '../assets/ashan/44.jpeg';
import galleImage2 from '../assets/ashan/43.jpeg';
import galleImage3 from '../assets/ashan/WhatsApp Image 2025-09-24 at 14.21.30.jpeg';
import ellaImage2 from '../assets/ashan/52.jpeg';
import ellaImage3 from '../assets/ashan/51.jpeg';
import nuwaraEliyaImage from '../assets/images/edited/WhatsApp Image 2025-10-02 at 19.45.17-Photoroom.png';
import nuwaraEliyaImage2 from '../assets/images/edited/15-Photoroom.png';
import nuwaraEliyaImage3 from '../assets/images/6.jpeg';
import nuwaraEliyaImage4 from '../assets/images/12.jpeg';
import bentotaRiverSafariImage from '../assets/ashan/coaster-bus_orig.jpg';
import bentotaRiverSafariImage2 from '../assets/ashan/8449390_orig.jpg';
import yalaSafariImage from '../assets/Home/Gallery/pexels-freestockpro-322480.jpg';
import yalaSafariImage2 from '../assets/Home/Gallery/pexels-rajee-kumar-1029496084-33130315.jpg';
import minneriyaImage from '../assets/Home/Gallery/pexels-nithin-thenkara-19419664-20228874.jpg';
import minneriyaImage2 from '../assets/Home/Gallery/pexels-dr-isura-wijayalath-63321856-8126089.jpg';
import udawalawaSafariImage from '../assets/Home/Gallery/pexels-elvimadushanka-12343661.jpg';
import udawalawaSafariImage2 from '../assets/Home/Gallery/pexels-hussain-niyaz-124838210-33672708.jpg';

import contactBg from '../assets/images/edited/pexels-alejo-marin-1157205539-21330181.jpg';
import villaImage from '../assets/images/edited/WhatsApp Image 2025-10-02 at 19.45.17-Photoroom.png';

const Home = () => {
    const { t } = useTranslation();
    const elementRef = useRef(null);
    const myElementRef = useRef(null);
    const [activeFilter, setActiveFilter] = useState('All');
    const [selectedImage, setSelectedImage] = useState(null);

    // Dynamically add the Elfsight script
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            console.log('Resize detected');
        });

        if (elementRef.current) {
            resizeObserver.observe(elementRef.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                console.log('Resizing detected:', entry.target);
            }
        });

        if (myElementRef.current) {
            resizeObserver.observe(myElementRef.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const images = {
        All: [
            { src: sigiriyaImage2, category: 'Tours', alt: t('homeSection.gallery.tours.sigiriya2') },
            { src: sigiriyaImage3, category: 'Tours', alt: t('homeSection.gallery.tours.sigiriya3') },
            { src: kandyImage2, category: 'Tours', alt: t('homeSection.gallery.tours.kandy2') },
            { src: kandyImage3, category: 'Tours', alt: t('homeSection.gallery.tours.kandy3') },
            { src: galleImage2, category: 'Tours', alt: t('homeSection.gallery.tours.galle2') },
            { src: galleImage3, category: 'Tours', alt: t('homeSection.gallery.tours.galle3') },
            { src: ellaImage2, category: 'Tours', alt: t('homeSection.gallery.tours.ella2') },
            { src: ellaImage3, category: 'Tours', alt: t('homeSection.gallery.tours.ella3') },
            { src: bentotaRiverSafariImage, category: 'Transportation', alt: t('homeSection.gallery.transportation.bentotaRiverSafari1') },
            { src: bentotaRiverSafariImage2, category: 'Transportation', alt: t('homeSection.gallery.transportation.bentotaRiverSafari2') },
            { src: yalaSafariImage, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.yalaSafari1') },
            { src: yalaSafariImage2, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.yalaSafari2') },
            { src: minneriyaImage, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.minneriya1') },
            { src: minneriyaImage2, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.minneriya2') },
            { src: udawalawaSafariImage, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.udawalawaSafari1') },
            { src: udawalawaSafariImage2, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.udawalawaSafari2') },

            { src: nuwaraEliyaImage, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya1') },
            { src: nuwaraEliyaImage2, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya2') },
            { src: nuwaraEliyaImage3, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya3') },
            { src: nuwaraEliyaImage4, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya4') },
        ],
        Tours: [
            { src: sigiriyaImage2, category: 'Tours', alt: t('homeSection.gallery.tours.sigiriya2') },
            { src: sigiriyaImage3, category: 'Tours', alt: t('homeSection.gallery.tours.sigiriya3') },
            { src: kandyImage2, category: 'Tours', alt: t('homeSection.gallery.tours.kandy2') },
            { src: kandyImage3, category: 'Tours', alt: t('homeSection.gallery.tours.kandy3') },
            { src: galleImage2, category: 'Tours', alt: t('homeSection.gallery.tours.galle2') },
            { src: galleImage3, category: 'Tours', alt: t('homeSection.gallery.tours.galle3') },
            { src: ellaImage2, category: 'Tours', alt: t('homeSection.gallery.tours.ella2') },
            { src: ellaImage3, category: 'Tours', alt: t('homeSection.gallery.tours.ella3') },
        ],
        Accommodation: [
            { src: nuwaraEliyaImage, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya1') },
            { src: nuwaraEliyaImage2, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya2') },
            { src: nuwaraEliyaImage3, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya3') },
            { src: nuwaraEliyaImage4, category: 'Accommodation', alt: t('homeSection.gallery.accommodation.nuwaraEliya4') },
        ],
        Transportation: [
            { src: bentotaRiverSafariImage, category: 'Transportation', alt: t('homeSection.gallery.transportation.bentotaRiverSafari1') },
            { src: bentotaRiverSafariImage2, category: 'Transportation', alt: t('homeSection.gallery.transportation.bentotaRiverSafari2') },
        ],
        Wildlife: [
            { src: yalaSafariImage, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.yalaSafari1') },
            { src: yalaSafariImage2, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.yalaSafari2') },
            { src: minneriyaImage, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.minneriya1') },
            { src: minneriyaImage2, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.minneriya2') },
            { src: udawalawaSafariImage, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.udawalawaSafari1') },
            { src: udawalawaSafariImage2, category: 'Wildlife', alt: t('homeSection.gallery.wildlife.udawalawaSafari2') },
        ],
    };

    const filteredImages = images[activeFilter];

    const openImageModal = (imageSrc) => {
        setSelectedImage(imageSrc);
    };

    const closeImageModal = () => {
        setSelectedImage(null);
    };

    return (

        <div className="py-4 px-4  space-y-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen">
            <HomeHero />
            {/* Why Choose Us Section */}
            <section className="max-w-7xl mx-auto">
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                    {t('homeSection.whyChooseUs.title')}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 bg-white p-8 rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
                    {[
                        {
                            icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
                            key: 'specialist',
                        },
                        {
                            icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
                            key: 'experience',
                        },
                        {
                            icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
                            key: 'priceMatch',
                        },
                        {
                            icon: 'M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 0118 0z',
                            key: 'support',
                        },
                    ].map((item, index) => (
                        <div key={item.key} className="flex items-start space-x-4 p-4 rounded-lg bg-[#F8F1E9] hover:bg-[#E6E0D8] transition-colors duration-200">
                            <svg className="w-20 h-20 text-[#C58E2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={item.icon}></path>
                            </svg>
                            <div className="space-y-2">
                                <h3 className="text-xl font-semibold text-[#122C56]">{t(`homeSection.whyChooseUs.${item.key}.title`)}</h3>
                                <p className="text-gray-600 leading-relaxed">{t(`homeSection.whyChooseUs.${item.key}.description`)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Welcome Section */}
            <section className="max-w-7xl mx-auto">
                {/* Layout for sm and md screens */}
                <div className="flex flex-col items-center lg:hidden">
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                        {t('homeSection.welcome.title')}
                    </h1>
                    <div className="w-full flex justify-center mb-8">
                        <img
                            src={tourImage}
                            alt={t('homeSection.welcome.imageAlt')}
                            className="w-full max-w-[80%] sm:max-w-[70%] md:max-w-[60%] rounded-2xl shadow-2xl transform hover:scale-[1.05] transition-transform duration-300 object-cover"
                        />
                    </div>
                    <div className="w-full text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed text-center space-y-4">
                        <p>{t('homeSection.welcome.description1')}</p>
                        <p>{t('homeSection.welcome.description2')}</p>
                        <p>{t('homeSection.welcome.description3')}</p>
                        <p>{t('homeSection.welcome.description4')}</p>
                        <p>{t('homeSection.welcome.description5')}</p>
                    </div>
                </div>

                {/* Layout for lg and larger screens */}
                <div className="hidden lg:flex flex-row items-center justify-between">
                    <div className="w-1/2 text-gray-600 text-lg leading-relaxed pr-12">
                        <h1 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                            {t('homeSection.welcome.title')}
                        </h1>
                        <p>{t('homeSection.welcome.description1')}</p>
                        <p className="mt-4">{t('homeSection.welcome.description2')}</p>
                        <p className="mt-4">{t('homeSection.welcome.description3')}</p>
                        <p className="mt-4">{t('homeSection.welcome.description4')}</p>
                        <p className="mt-4">{t('homeSection.welcome.description5')}</p>
                    </div>
                    <div className="w-1/2 flex justify-center">
                        <img
                            src={tourImage}
                            alt={t('homeSection.welcome.imageAlt')}
                            className="w-full max-h-[800px] rounded-2xl shadow-2xl transform hover:scale-[1.05] transition-transform duration-300 object-cover"
                        />
                    </div>
                </div>
            </section>

            {/* Cinnamon Luxury Villa Section */}
            <section className="max-w-7xl mx-auto bg-[#F8F1E9] p-8 rounded-2xl shadow-2xl">
                {/* Layout for sm and md screens */}
                <div className="flex flex-col items-center lg:hidden">
                    <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                        {t('homeSection.cinnamonLuxuryVilla.title')}
                    </h2>
                    <div className="w-full flex justify-center mb-8">
                        <img
                            src={villaImage}
                            alt={t('homeSection.cinnamonLuxuryVilla.imageAlt')}
                            className="w-full max-w-[100%] sm:max-w-[100%] md:max-w-[60%] rounded-2xl shadow-2xl transform hover:scale-[1.05] transition-transform duration-300 object-cover"
                        />
                    </div>
                    <div className="w-full text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed text-center space-y-4">
                        <p>{t('homeSection.cinnamonLuxuryVilla.description1')}</p>
                        <p>{t('homeSection.cinnamonLuxuryVilla.description2')}</p>
                    </div>
                    <div className="mt-8">
                        <Link
                            to="/about-us"
                            className="px-8 py-4 bg-[#C58E2F] text-white font-semibold rounded-lg shadow-md hover:bg-[#A57324] hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                        >
                            {t('homeSection.cinnamonLuxuryVilla.readMore')}
                        </Link>
                    </div>
                </div>

                {/* Layout for lg and larger screens */}
                <div className="hidden lg:flex flex-row items-center justify-between">
                    <div className="w-1/2 flex justify-center">
                        <img
                            src={villaImage}
                            alt={t('homeSection.cinnamonLuxuryVilla.imageAlt')}
                            className="w-full max-h-[600px] rounded-2xl shadow-2xl transform hover:scale-[1.05] transition-transform duration-300 object-cover"
                        />
                    </div>
                    <div className="w-1/2 text-gray-600 text-lg leading-relaxed pl-12">
                        <h2 className="text-4xl lg:text-5xl font-extrabold text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                            {t('homeSection.cinnamonLuxuryVilla.title')}
                        </h2>
                        <p>{t('homeSection.cinnamonLuxuryVilla.description1')}</p>
                        <p className="mt-4">{t('homeSection.cinnamonLuxuryVilla.description2')}</p>
                        <div className="mt-8">
                            <Link
                                to="/about-us"
                                className="px-8 py-4 bg-[#C58E2F] text-white font-semibold rounded-lg shadow-md hover:bg-[#A57324] hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                            >
                                {t('homeSection.cinnamonLuxuryVilla.readMore')}
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Google Reviews Section */}
            <section className="max-w-7xl mx-auto">
                <div className="flex justify-center">
                    <div className="elfsight-app-29a4c44d-1a90-43c8-87c0-fe506394e888 w-full rounded-2xl shadow-2xl p-8 bg-white" data-elfsight-app-lazy></div>
                </div>
            </section>

            {/* Tour Packages Section */}
            <section className="max-w-7xl mx-auto">
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                    {t('homeSection.tourPackages.title')}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        { image: sigiriyaImage, key: 'ella', alt: t('homeSection.tourPackages.ella.alt') },
                        { image: kandyImage, key: 'ellaNuwaraKandy', alt: t('homeSection.tourPackages.ellaNuwaraKandy.alt') },
                        { image: galleImage, key: 'kandyNuwaraEllaYala', alt: t('homeSection.tourPackages.kandyNuwaraEllaYala.alt') },
                    ].map((tour, index) => (
                        <div
                            key={tour.key}
                            className="relative bg-white rounded-2xl shadow-2xl overflow-hidden transform hover:scale-[1.05] transition-transform duration-300 w-full max-w-sm mx-auto"
                        >
                            <div className="relative">
                                <img
                                    src={tour.image}
                                    alt={tour.alt}
                                    className="w-full h-64 object-cover transform hover:scale-110 transition-transform duration-500"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">

                                </div>
                            </div>
                            <div className="bg-[#F8F1E9] text-[#122C56] p-6 text-center">
                                <h3 className="text-xl font-semibold">{t(`homeSection.tourPackages.${tour.key}.title`)}</h3>
                                <p className="text-sm text-gray-600 mt-2">{t(`homeSection.tourPackages.${tour.key}.subtitle`)}</p>
                                <p className="text-sm text-gray-600 mt-3 leading-relaxed">{t(`homeSection.tourPackages.${tour.key}.description`)}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex justify-center mt-10">
                    <Link
                        to="/tour"
                        className="px-8 py-4 bg-[#C58E2F] text-white font-semibold rounded-lg shadow-md hover:bg-[#A57324] hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                    >
                        {t('homeSection.tourPackages.viewMore')}
                    </Link>
                </div>
            </section>

            {/* Popular Excursions Section */}
            <section className="max-w-7xl mx-auto">
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                    {t('homeSection.popularExcursions.title')}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {[
                        { image: oneDayImage, key: 'oneDay', alt: t('homeSection.popularExcursions.oneDay.alt') },
                        { image: twoDayImage, key: 'twoDays', alt: t('homeSection.popularExcursions.twoDays.alt') },
                        { image: threeDayImage, key: 'threeDays', alt: t('homeSection.popularExcursions.threeDays.alt') },
                        { image: fourDayImage, key: 'fourDays', alt: t('homeSection.popularExcursions.fourDays.alt') },
                    ].map((excursion, index) => (
                        <div
                            key={excursion.key}
                            className="relative bg-white rounded-2xl shadow-2xl overflow-hidden transform hover:scale-[1.05] transition-transform duration-300 w-full max-w-xs mx-auto"
                        >
                            <div className="relative">
                                <img
                                    src={excursion.image}
                                    alt={excursion.alt}
                                    className="w-full h-64 object-cover transform hover:scale-110 transition-transform duration-500"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">

                                </div>
                            </div>
                            <div className="bg-[#F8F1E9] text-[#122C56] p-6 text-center">
                                <h3 className="text-xl font-semibold">{t(`homeSection.popularExcursions.${excursion.key}.title`)}</h3>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex justify-center mt-10">
                    <Link
                        to="/excursions"
                        className="px-8 py-4 bg-[#C58E2F] text-white font-semibold rounded-lg shadow-md hover:bg-[#A57324] hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                    >
                        {t('homeSection.popularExcursions.viewMore')}
                    </Link>
                </div>
            </section>

            {/* Contact Us Section */}
            <section
                className="relative max-w-7xl mx-auto p-8 rounded-2xl shadow-2xl bg-cover bg-center "
                style={{ backgroundImage: `url(${contactBg})` }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-60 rounded-2xl"></div>
                <div className="relative z-10 flex flex-col items-center justify-center text-center">
                    <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-12 tracking-tight drop-shadow-md">
                        {t('homeSection.contactUs.title')}
                    </h2>
                    <p className="text-lg sm:text-xl md:text-2xl text-gray-100 max-w-3xl mx-auto mb-10 leading-relaxed">
                        {t('homeSection.contactUs.description')}
                    </p>
                    <Link
                        to="/contact-us"
                        className="px-8 py-4 bg-[#C58E2F] text-white font-semibold rounded-lg shadow-md hover:bg-[#A57324] hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                    >
                        {t('homeSection.contactUs.button')}
                    </Link>
                </div>
            </section>

            {/* Gallery Section */}
            <section className="max-w-7xl mx-auto">
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                    {t('homeSection.gallery.title')}
                </h2>
                <div className="flex justify-center gap-4 sm:gap-6 mb-10 flex-wrap">
                    {['All', 'Tours', 'Accommodation', 'Transportation', 'Wildlife'].map((filter) => (
                        <button
                            key={filter}
                            onClick={() => setActiveFilter(filter)}
                            className={`px-6 py-3 font-semibold rounded-lg shadow-md transition-all duration-200 transform hover:scale-105 ${activeFilter === filter
                                ? 'bg-[#C58E2F] text-white'
                                : 'bg-[#F8F1E9] text-[#122C56] hover:bg-[#A57324] hover:text-white'
                                }`}
                        >
                            {t(`homeSection.gallery.filters.${filter.toLowerCase()}`)}
                        </button>
                    ))}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                    {filteredImages.map((image, index) => (
                        <div
                            key={index}
                            className="relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-[1.05] transition-transform duration-300 cursor-pointer aspect-[4/3] w-full"
                            onClick={() => openImageModal(image.src)}
                        >
                            <img
                                src={image.src}
                                alt={image.alt}
                                className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">

                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Image Modal */}
            {selectedImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
                    onClick={closeImageModal}
                >
                    <div className="relative max-w-5xl w-full aspect-[4/3] p-4">
                        <img
                            src={selectedImage}
                            alt={t('homeSection.gallery.modalAlt')}
                            className="w-full h-full object-contain rounded-2xl shadow-2xl"
                        />
                        <button
                            className="absolute top-6 right-6 text-white bg-[#C58E2F] rounded-full p-3 hover:bg-[#A57324] hover:shadow-lg transition-all duration-200"
                            onClick={closeImageModal}
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Home;